import styled from "styled-components";

const LoadingSpinner = styled.div`
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  width: ${props => props.width ? props.width : '30px'};
  height: ${props => props.height ? props.height : '30px'};
  min-width: ${props => props.width ? props.width : '30px'};
  min-height: ${props => props.height ? props.height : '30px'};
  max-width: ${props => props.width ? props.width : '30px'};
  max-height: ${props => props.height ? props.height : '30px'};
  animation: spin 2s linear infinite;
  margin: 0;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default LoadingSpinner;

